import type { Command } from '@atlaskit/editor-common/types';
import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import { getParameters, setParameters } from '@atlaskit/native-embeds-common/utils';

/**
 * Reads the current MAUI (remix) app/version id from a native embed node's parameters.
 */
export const getRemixAppId = (selectedNode: PMNode): string | undefined =>
	getParameters(selectedNode.attrs.parameters, 'remixAppId');

/**
 * Sets the MAUI (remix) app/version id on a native embed node's parameters.
 *
 * `remixAppId` is stamped on the managed iframe as a `data-remix-app-id` attribute rather than
 * baked into the iframe `src`, so this update swaps the rendered version without reloading the
 * iframe. And because it is an ordinary node-attribute transaction, the change participates in
 * the editor's undo/redo history for free — undoing a version edit restores the previous
 * `remixAppId`, which restamps the attribute with no reload.
 */
export const createSetRemixAppIdCommand =
	(remixAppId: string, pos: number, selectedNode: PMNode): Command =>
	(state, dispatch) => {
		if (dispatch) {
			dispatch(
				state.tr.setNodeMarkup(pos, undefined, {
					...selectedNode.attrs,
					parameters: setParameters(selectedNode.attrs.parameters, { remixAppId }),
				}),
			);
		}
		return true;
	};
